import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { GTFonts, PoppinsFonts, useTheme } from '../../theme';
import { s, fs, v } from '../../utils/libs';

type Props = {
  title?: string;
  message?: string | null;
  primaryActionLabel?: string;
  onPrimaryAction?: () => void | Promise<unknown>;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void | Promise<unknown>;
};

const BackOfficeFallback: React.FC<Props> = ({
  title = 'Something went wrong',
  message = 'Unable to load Back Office at the moment.',
  primaryActionLabel = 'Retry',
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
}) => {
  const { theme } = useTheme();
  const styles = createStyles(theme);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      {!!message && <Text style={styles.message}>{message}</Text>}
      <View style={styles.actionsRow}>
        {onPrimaryAction ? (
          <TouchableOpacity style={styles.primaryBtn} onPress={onPrimaryAction}>
            <Text style={styles.primaryText}>{primaryActionLabel}</Text>
          </TouchableOpacity>
        ) : null}
        {onSecondaryAction ? (
          <TouchableOpacity
            style={styles.secondaryBtn}
            onPress={onSecondaryAction}>
            <Text style={styles.secondaryText}>{secondaryActionLabel}</Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
};

export default BackOfficeFallback;

const createStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      padding: s(16),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.background,
    },
    title: {
      color: theme.colors.text,
      fontFamily: GTFonts.semibold,
      fontSize: fs(18),
      lineHeight: fs(22),
      marginBottom: v(6),
      textAlign: 'center',
    },
    message: {
      color: theme.colors.textSecondary,
      fontFamily: PoppinsFonts.regular,
      fontSize: fs(14),
      lineHeight: fs(18),
      marginBottom: v(12),
      textAlign: 'center',
    },
    actionsRow: {
      flexDirection: 'row',
      gap: s(10) as unknown as number,
      marginTop: v(4),
    },
    primaryBtn: {
      backgroundColor: theme.colors.primary,
      paddingVertical: s(10),
      paddingHorizontal: s(16),
      borderRadius: theme.borderRadius.md,
    },
    primaryText: {
      color: theme.colors.textInverse,
      fontFamily: PoppinsFonts.regular,
      fontSize: fs(14),
      lineHeight: fs(18),
    },
    secondaryBtn: {
      backgroundColor: theme.colors.surface,
      paddingVertical: s(10),
      paddingHorizontal: s(16),
      borderRadius: theme.borderRadius.md,
      borderWidth: 1,
      borderColor: theme.colors.borderGray,
    },
    secondaryText: {
      color: theme.colors.text,
      fontFamily: PoppinsFonts.regular,
      fontSize: fs(14),
    },
  });
